export default "__VITE_ASSET__a71acf6d__"